/**Import statements for Page Loader Component
 * @created 07/05/2022
 */

import { MotifProgressBar } from '@ey-xd/motif-react';
import { useEffect } from 'react';
import './index.scss';
/** Import statements end here */

const PageLoader = (props: any) => {
  const { isLoading } = props;

  // disabling scrollbar while the page is on loading
  useEffect(() => {
    if (!isLoading) {
      return;
    }

    const previousOverflowY = document.body.style.getPropertyValue('overflow-y');
    const previousOverflowYPriority = document.body.style.getPropertyPriority('overflow-y');

    document.body.style.setProperty('overflow-y', 'hidden', 'important');

    return () => {
      if (previousOverflowY) {
        document.body.style.setProperty('overflow-y', previousOverflowY, previousOverflowYPriority || undefined);
      } else {
        document.body.style.removeProperty('overflow-y');
      }
    };
  }, [isLoading]);

  // Actual search box component rendered over here
  return isLoading ? (
    <div className="loader-container">
      <MotifProgressBar circle isIndeterminate hideLabel className="loader" />
    </div>
  ) : null;
};
export { PageLoader };
